// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__R1A6a","links":"footer_links__7XePM","link":"footer_link__a8fUV","logo":"footer_logo__FlWYo"};